/*       */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Widget from 'app/components/atoms/Widget/Widget';
import { bind, memoize } from 'app/utils/decorators/decoratorUtils';
import ALiveItem from 'app/containers/Abox/ALive/ALiveItem';
import { sortChats } from 'app/utils/chat/chatUtils';
import { widgetTypes } from '../dashboardUtils';

/**
 * Widget for displaying tasks assigned to the active user
 */
class AliveWidget extends PureComponent {
    static propTypes = {
        unreadMessages: PropTypes.array,
    };

    @bind
    @memoize()
    renderChatItem(data) {
        return (
            <div key={data.rid}>
                <ALiveItem appearance='medium' data={data} isAliveWidget hideMoreOptions />
            </div>
        );
    }

    render() {
        const { unreadMessages, isLoading, item, menuItemClick, permissions } = this.props;
        return (
            <Widget
                title='A-live Messages'
                subHeader='Activity'
                content={!unreadMessages?.length ? 'No unread messages' : unreadMessages.map(this.renderChatItem)}
                url={`/abox/alive`}
                isLoading={isLoading}
                menuItemClick={menuItemClick}
                isSystem
                permissions={permissions}
                item={item}
                type={widgetTypes.alive}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const subscriptions = state.chat.subscriptions.data || [];
    const unreadMessages = sortChats(
        'activity',
        subscriptions.filter(({ unread }) => unread)
    ).slice(0, 30);
    return {
        unreadMessages,
        isLoading: state.chat.subscriptions.isLoading,
    };
};

export default connect(mapStateToProps, null)(AliveWidget);
